// Continuous-scroll wordmark marquee for clients (no hover pause, not clickable per spec).
const CLIENTS = [
  { name: "Girman Tech", accent: "cyan" },
  { name: "fenmo", accent: "green" },
  { name: "KAINest", accent: "cyan" },
  { name: "Adrush", accent: "green" },
  { name: "Pixaver", accent: "green" },
  { name: "Northwind Labs", accent: "cyan" },
  { name: "Helix Cloud", accent: "green" },
  { name: "Stratos AI", accent: "cyan" },
];

// Duplicate the array so the translateX(-50%) loop appears seamless.
const TRACK = [...CLIENTS, ...CLIENTS];

export default function ClientLogos() {
  return (
    <section
      data-testid="client-logos"
      className="relative border-b border-white/10 bg-carbon overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-5 lg:px-8 pt-20 pb-10">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6 mb-10">
          <div>
            <div className="chip text-neon-cyan">&gt; /trusted_by</div>
            <h2 className="mt-3 font-display font-black text-3xl md:text-4xl text-white leading-tight">
              Teams who trust United Techlab.
            </h2>
          </div>
          <p className="max-w-sm text-white/50 text-sm leading-relaxed">
            Fast-moving companies and elite engineering teams that rely on us as
            their accountable engineering partner.
          </p>
        </div>
      </div>

      {/* Marquee track */}
      <div className="relative border-y border-white/10 bg-obsidian">
        {/* fade edges */}
        <div className="pointer-events-none absolute left-0 top-0 bottom-0 w-24 z-10 bg-gradient-to-r from-obsidian to-transparent" />
        <div className="pointer-events-none absolute right-0 top-0 bottom-0 w-24 z-10 bg-gradient-to-l from-obsidian to-transparent" />

        <div className="overflow-hidden py-10">
          <div
            className="flex w-max animate-marquee gap-16 px-8"
            data-testid="client-logos-track"
          >
            {TRACK.map((c, i) => (
              <div
                key={`${c.name}-${i}`}
                className="flex-shrink-0 flex items-center justify-center"
                aria-hidden={i >= CLIENTS.length}
              >
                <span
                  className={`font-display font-black text-3xl md:text-4xl tracking-tight whitespace-nowrap text-white/80 hover:text-white transition-colors ${
                    c.accent === "green" ? "hover:text-glow-green" : "hover:text-glow-cyan"
                  }`}
                >
                  {c.name}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-6">
        <p className="text-xs font-mono text-white/40">
          // wordmarks shown — replace with official logos when provided by clients.
        </p>
      </div>
    </section>
  );
}
